<template>

     <mu-bottom-sheet 
        :open="cookies" 
        :overlay="overlay" 
        :overlay-close="overlayClose"
        :overlay-opacity="overlayOpacity"
        :overlay-color="overlayColor"
        :esc-press-close="escPressclose"
        :append-body="appendBody">
        <mu-list>
            <mu-list-item>
                <mu-list-item-content>
                    <mu-list-item-sub-title>
                        {{ $t('cookies.paragraph.p1') }}
                        <br>{{ $t('cookies.paragraph.p2') }}
                    </mu-list-item-sub-title>
                </mu-list-item-content>
                <mu-list-item-action>
                    <slot name="actions" />
                </mu-list-item-action>
            </mu-list-item>
        </mu-list>
    </mu-bottom-sheet>
</template>
<script>
    // HELPERS
    import _GlobalHelper from '@/store/helpers/global'
    // VUEX
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        props: {
            overlay: {
                type: Boolean,
                default: false
            },
            overlayClose: {
                type: Boolean,
                default: true
            },
            overlayOpacity: {
                type: Number,
                default: .4
            },
            overlayColor: {
                type: String,
                default: '#000'
            },
            escPressclose: {
                type: Boolean,
                default: false
            },
            appendBody: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters({
                cookies: _GlobalHelper.getters.accept_cookie
            }),
        },
        methods: {
            ...mapMutations({
                set_cookies: _GlobalHelper.mutations.setAcceptCookies
            })
        },
        created() {
            
        }
    }
</script>